import { useState } from 'react';
import { NextgenImage, type NextgenImageProps, FAIcon, IconStyle } from '@nextgen-web-framework/all';
import { type IconName } from '@fortawesome/pro-solid-svg-icons';
import styles from './CartImageComponent.module.scss';

export const CartImageComponent = (props: NextgenImageProps) => {
  const { src } = props;
  const [error, setError] = useState(false);
  const [iconName, setIconName] = useState<IconName | undefined>('image');

  const handleErrorChange = () => {
    setError(true);
    setIconName('image-slash');
  };

  return (
    <>
      {!src || error ? (
        <div className={styles['no-image-container']}>
          <FAIcon className={styles['no-image-container-icon']} iconName={iconName} iconStyle={IconStyle.REGULAR} />
        </div>
      ) : (
        <NextgenImage onError={handleErrorChange} {...props} />
      )}
    </>
  );
};
